import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__negative-input';
export default class NegativeInput {
    static init($root = $('body')) {
        const $input = $root.find(ELEMENT_SELECTOR);
        $input.each((index, element) => {
            const $input = $(element);
            this.makeValueNegative($input);
        });
        $input.on('keyup', e => {
            this.makeValueNegative($(e.currentTarget));
        });
    }
    static makeValueNegative($input) {
        const value = String($input.val()) || '';
        const isNegative = value.startsWith('-');
        const isZeroOrEmpty = Number(value) === 0 || value === '';
        if (!isNegative && !isZeroOrEmpty) {
            $input.val(`-${$input.val()}`);
        }
    }
}
